import type { TView } from '@alfa-bank/site-text-v2/src/models';
import type { TDesignGapsIndent } from '@alfa-bank/site-util-create-widget/src/models';

export type TConfig = {
    marginBottom: TDesignGapsIndent;
    marginTop: TDesignGapsIndent;
    view: TView;
};

export const configDesktop: TConfig = { marginTop: 48, marginBottom: 24, view: 'medium' };

export const configMobile: TConfig = { marginTop: 32, marginBottom: 16, view: 'medium' };
